import { ref as f, readonly as l, getCurrentScope as p, onScopeDispose as d, unref as m, getCurrentInstance as y, onMounted as g, nextTick as b } from "vue";
function O(e) {
  return p() ? (d(e), !0) : !1;
}
function S(e) {
  return typeof e == "function" ? e() : m(e);
}
const j = typeof window < "u" && typeof document < "u", v = Object.prototype.toString, C = (e) => v.call(e) === "[object Object]", w = () => {
};
function x(e, o = !0) {
  y() ? g(e) : o ? e() : b(e);
}
function D(e, o, r = {}) {
  const {
    immediate: c = !0
  } = r, t = f(!1);
  let n = null;
  function u() {
    n && (clearTimeout(n), n = null);
  }
  function i() {
    t.value = !1, u();
  }
  function s(...a) {
    u(), t.value = !0, n = setTimeout(() => {
      t.value = !1, n = null, e(...a);
    }, S(o));
  }
  return c && (t.value = !0, j && s()), O(i), {
    isPending: l(t),
    start: s,
    stop: i
  };
}
export {
  O as a,
  x as b,
  j as c,
  C as i,
  w as n,
  S as t,
  D as u
};
//# sourceMappingURL=index-1fa6eebe.js.map
